import {
	icons as characterIcons
} from './characters';
import skillList from '../data/skills.json';

const FILTERS_DEF = Object.freeze([
	{
		name: 'name',
		type: 'text',
		default: ''
	},
	{
		name: 'rank',
		type: 'multi-select',
		hideLabel: true,
		iconSize: 'sm',
		values: [
			{ key: 0, name: 'B', icon: '/d/df/Rank_B.png'	},
			{ key: 1, name: 'A', icon: '/4/49/Rank_A.png'	},
			{ key: 2, name: 'S', icon: '/7/7e/Rank_S.png'	}
		],
		default: []
	},
	{
		name: 'type',
		type: 'multi-select',
		hideLabel: true,
		iconSize: 'sm',
		values: [
			{ key: 0, name: 'Red', 		icon: '/6/66/Card_Red.png'		},
			{ key: 1, name: 'Yellow', icon: '/0/0e/Card_Yellow.png'	},
			{ key: 2, name: 'Blue', 	icon: '/1/13/Card_Blue.png'		},
			{ key: 3, name: 'Green', 	icon: '/6/6c/Card_Green.png'	}
		],
		default: []
	},
	{
		name: 'owned',
		type: 'multi-select',
		values: [
			{ key: 'r5', name: 'rank 5'		},
			{ key: 'r0', name: 'rank <=4'	}
		],
		default: []
	},
	{
		name: 'sort',
		type: 'select',
		values: [
			{ key: 'id', name: 'ID' },
			{ key: 'type', name: 'Type' },
			{ key: 'rank', name: 'Rank' },
			{ key: 'name', name: 'Name' }
		],
		default: 'id'
	},
	{
		name: 'require',
		type: 'combination-composer',
		values: [
			{ key: 0, name: 'Red', 		icon: '/6/66/Card_Red.png'		},
			{ key: 1, name: 'Yellow', icon: '/0/0e/Card_Yellow.png'	},
			{ key: 2, name: 'Blue', 	icon: '/1/13/Card_Blue.png'		},
			{ key: 3, name: 'Green', 	icon: '/6/6c/Card_Green.png'	}
		],
		max: 3,
		default: []
	},
	{
		name: 'skills',
		type: 'multi-select',
		labelPosition: 'top',
		subtypes: true,
		search(text) {
			const def = FILTERS_DEF.find(d => d.name === 'skills');
			const values = def.baseValues;
			if (!text)
				return [ ...values ];
			const searchRegExp = new RegExp(text
				.trim()
				.replace(/([^\s]+)\s?/g, '.*$1')
				+ '.*', 'i');
			return values.filter(v => {
				return searchRegExp.test(v.key);
			});
		},
		baseValues: Object.entries(skillList)
			.reduce((values, [ skillName, skillDef ]) => {
				const category = skillDef.category ? skillDef.category.split('-')[0].replace('_', ' ') : skillDef.type;
				const value = {
					category,
					tags: skillDef.category
				};
				if (category === 'character') {
					for (const skillKey of Object.keys(skillDef)) {
						if ([ 'type', 'icon', 'unique' ].includes(skillKey))
							continue;
						const key = `character-${skillKey}`;
						if (!values.find(v => v.key === key)) {
							values.push({
								...value,
								key,
								name: skillKey,
								icon: characterIcons[skillKey] ?? '/8/81/Randomly_draw_hidden_skill.png'
							});
						}
					}
				} else {
					values.push({
						...value,
						key: skillName,
						icon: skillDef.icon ?? '/8/81/Randomly_draw_hidden_skill.png'
					});
				}
				return values;
			}, []).sort((a, b) => {
				if (a.category === b.category
				&& a.tags && b.tags && a.tags !== b.tags)
					return a.tags.localeCompare(b.tags);
				return a.key.localeCompare(b.key);
			}),
		default: []
	}
]);

FILTERS_DEF.forEach(def => {
	if (def.search) {
		def.values = def.search('');
		def.searchText = '';
	}
});

const FILTERS_DEFAULT = Object.freeze(FILTERS_DEF.reduce((filterObj, filterDef) => {
	filterObj[filterDef.name] = filterDef.default;
	return filterObj;
}, {}));

export {
	FILTERS_DEFAULT,
	FILTERS_DEF
};
